import React, { useState } from "react";
import CardComponent from "./Card/Card";
import ModalUI from "../../../../components/modalUI/ModalUI";
import { AutomaticWithdrawalModal } from "./AutomaticWithdrawalModal";
import { SelectChangeEvent } from "@mui/material";
import {
  useCreateWithdrawalMutation,
  useGetWithdrawalsQuery,
} from "../../../../service/userAutomaticDrawal/createUserAutomaticDrawal.service";
import Message from "../../../../components/notification/message/message";

const AutomaticWithDrawals = ({ data, bankAccount }: any) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [account, setAccount] = useState<Object>();
  const [amountType, setAmountType] = useState<string>("full");
  const [frequency, setFrequency] = useState<string>("");
  const [payDay, setPayDay] = useState<string>("");
  //const [specificAmount, setSpecificAmount] = useState(5500);
  //const [safetyLimit, setSafetyLimit] = useState(5000);

  const [notify, setNotify] = useState({
    open: false,
    message: "",
    severity: "info" as "success" | "info" | "warning" | "error",
  });

  const handleChange = (event: SelectChangeEvent) => {
    setAccount(event.target.value as string);
  };

  const handleChangeFrequency = (event: SelectChangeEvent) => {
    setFrequency(event.target.value as string);
  };

  const handleChangePayDay = (event: SelectChangeEvent) => {
    setPayDay(event.target.value as string);
  };

  const onClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setNotify({ ...notify, open: false });
  };

  const objectAutomaticWithdrawal = () => ({
    amount: 0,
    config: {
      amountType: amountType,
      frequency: frequency,
      payday: payDay,
    },
    account: account ?? [],
  });

  const [
    createWithdrawal,
    { data: created, isLoading: creating, error: createError },
  ] = useCreateWithdrawalMutation();

  const {
    data: withdrawals,
    isLoading: loadingList,
    error: listError,
    refetch,
  } = useGetWithdrawalsQuery();

  const handleSubmit = () => {
    createWithdrawal(objectAutomaticWithdrawal())
      .unwrap()
      .then((res) => {
        setNotify({
          open: true,
          message: "¡Configuracion exitosa!",
          severity: "success",
        });
        setOpenModal(false)
        refetch()
      })
      .catch(() => {
        setNotify({
          open: true,
          message: "Ha acurrido un error",
          severity: "error",
        });
      });
  };

  return (
    <>
      <CardComponent openModal={onClickOpenModal} data={withdrawals} />
      <ModalUI
        children={
          <AutomaticWithdrawalModal
            data={data}
            setAmountType={setAmountType}
            amountType={amountType}
            handleBank={handleChange}
            dataBank={bankAccount}
            bank={account}
            handleChangeFrequency={handleChangeFrequency}
            handleChangePayDay={handleChangePayDay}
            frequency={frequency}
            onClick={handleSubmit}
            loading={creating}
          />
        }
        setOpen={setOpenModal}
        open={openModal}
      />
      <Message
        open={notify.open}
        message={notify.message}
        severity={notify.severity}
        onClose={handleClose}
      />
    </>
  );
};

export default AutomaticWithDrawals;
